'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.normalize = void 0;
var tslib_1 = require("tslib");
/**
 * Recursively converts the response properties from CapitalizedCase to
 * camelCase. If properties are already in camel case then
 * no modification is made.
 *
 * As typescript cannot augment property name changes in
 * definitions, you need to pass through the output type.
 *
 * This function is needed as some magic methods return the
 * incorrect casing as per our standards.
 *
 * TODO: Fix partial type inference https://github.com/Microsoft/TypeScript/issues/10571
 */
function normalize(input) {
    var initialValue = !Array.isArray(input) ? {} : [];
    return Object.entries(input).reduce(function (output, _a) {
        var _b = tslib_1.__read(_a, 2), key = _b[0], value = _b[1];
        var newValue = !!value && typeof value === 'object' ? normalize(value) : value;
        if (typeof key === 'string') {
            var newKey = void 0;
            if (isUpperCase(key)) {
                newKey = key.toLowerCase();
            }
            else {
                var firstChar = (key[0] || '').toLowerCase();
                newKey = "" + firstChar + key.substr(1, key.length);
            }
            // TODO: Try to resolve this type issue if possible
            output[newKey] = newValue;
        }
        else {
            output.push(newValue);
        }
        return output;
    }, initialValue);
}
exports.normalize = normalize;
function isUpperCase(str) {
    return str === str.toUpperCase();
}
